"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.seekLimiter = void 0;
var seekLimiter = exports.seekLimiter = function seekLimiter(player) {
  var _player$options = player.options(),
    hasHiddenAvComponent = _player$options.hasHiddenAvComponent;
  return {
    setCurrentTime: function setCurrentTime(ct) {
      if (player.scrubbing() && hasHiddenAvComponent) {
        return player.currentTime();
      }
      return ct;
    }
  };
};